import Client from './Client';

export default class OrderClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 订单管理
   */
  async pageCourseRegistrationListBackend(data) {
    const res = await this.client.post('/api/course/registration/pageCourseRegistrationListBackend', data);
    return res;
  }

  /**
   * 订单详情
   */
  async getCourseRegistrationListBackend(data) {
    const res = await this.client.post('/api/course/registration/getCourseRegistrationListBackend', data);
    return res;
  }

  /**
   * 订单后台退款
   */
  async refundByBackendUser(data) {
    const res = await this.client.post('/api/course/registration/refundByBackendUser', data);
    return res;
  }

  /**
   * 修改订单对应机构
   */
  async updateCourseRegistrationAgency(data) {
    const res = await this.client.post('/api/distribution/updateCourseRegistrationAgency', data);
    return res;
  }

  /**
   * 视频考试列表
   */
  async videoExamList(data) {
    const res = await this.client.post('/api/exam/videoExamList', data);
    return res;
  }

  /**
   * 修改视频考试章节
   */
  async updateVideoExamChapter(data) {
    const res = await this.client.post('/api/exam/updateVideoExamChapter', data);
    return res;
  }

  /**
   * 上传视频考试
   */
  async uploadVideoExamBackend(data) {
    const res = await this.client.post('/api/exam/uploadVideoExamBackend', data);
    return res;
  }
}
